import { cn } from '../../utils/cn'

export type SkeletonShape = 'text' | 'rect' | 'circle'

export interface SkeletonProps {
  shape?: SkeletonShape
  /** Number of stacked lines; only meaningful for shape="text". */
  lines?: number
  className?: string
}

const SHAPES: Record<SkeletonShape, string> = {
  text: 'h-4 rounded',
  rect: 'rounded-xl',
  circle: 'rounded-full',
}

export function Skeleton({ shape = 'text', lines = 1, className }: SkeletonProps) {
  if (shape === 'text' && lines > 1) {
    return (
      <div aria-hidden="true" className="flex flex-col gap-3">
        {Array.from({ length: lines }, (_, i) => (
          <div
            key={i}
            className={cn(
              'animate-pulse bg-surface-container-high',
              SHAPES.text,
              // Ragged last line so a loading paragraph reads as a paragraph.
              i === lines - 1 ? 'w-2/3' : 'w-full',
              className,
            )}
          />
        ))}
      </div>
    )
  }

  return <div aria-hidden="true" className={cn('animate-pulse bg-surface-container-high', SHAPES[shape], className)} />
}
